/**
 * Optional `height` of the portal's 'omp:prompter-state' message: the
 * measured CSS px of its card. Bounded to 22..640; anything else (absent,
 * non-numeric, an older portal) keeps the fixed default.
 */
const LINKS = new Set(['idle', 'connecting', 'connected', 'disconnected']);

/** Optional `link` of 'omp:prompter-state'; null when absent or unknown (an older portal). */
export function prompterFrameLink(value: unknown): 'idle' | 'connecting' | 'connected' | 'disconnected' | null {
  // 'native': OMP Tools shows the script, the portal prompter is off: the OMP Advertising dot goes idle.
  if (value === 'native') return 'idle';
  return typeof value === 'string' && LINKS.has(value) ? (value as 'idle' | 'connecting' | 'connected' | 'disconnected') : null;
}

/** 'omp:prompter-state' reports `link: 'native'` when OMP Tools is operational and the portal prompter stands down. */
export function prompterFrameNative(value: unknown): boolean {
  return value === 'native';
}

export function prompterFrameHeight(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? Math.min(640, Math.max(22, Math.ceil(value))) : null;
}
